import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'El problema',
  href: '#problema'
}, {
  label: 'El recorrido',
  href: '#sistema'
}, {
  label: 'Método M.V.P.™',
  href: '#metodo'
}, {
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: '60 recetas',
  href: '#recetas'
}, {
  label: 'Los 5 bonos',
  href: '#bonos'
}, {
  label: 'Para quién es',
  href: '#para-quien'
}, {
  label: 'Precio y acceso',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="bg-sand" data-id="element-125" data-mp="29ynmxp3fzdg4">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:py-14" data-id="element-126" data-mp="29xvpe8qab5n7">
        <div className="grid gap-8 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-127" data-mp="2eyjpdjwhqwtk">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-128" data-mp="3lalfndz543tf">
            <p className="font-display text-[1.4rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[1.6rem]" data-id="element-129" data-mp="3lbmw5xyxdiij">
              Postres que <span className="text-gold" data-id="element-130" data-mp="3v8rhjvky59ya">Venden™</span>
            </p>
            <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-white px-3.5 py-1.5 font-display text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-131" data-mp="3q8wrfu8zwoea">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-132" data-mp="80ntcj7a4qcv" />
              60 recetas + 5 bonos
            </p>
            <p className="mt-4 max-w-sm font-sans text-[0.84rem] leading-relaxed text-taupe" data-id="element-133" data-mp="htd0j1vsri2e">
              El sistema práctico para elegir qué preparar, organizar tu cocina, calcular costos,
              presentar tus productos y empezar a vender postres desde casa.
            </p>
            <p className="mt-4 max-w-sm font-display text-[0.9rem] font-semibold leading-snug text-charcoal/80" data-id="element-134" data-mp="ms6fkyqqfh4o">
              Elegir · Organizar · Producir · Presentar · Vender
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-135" data-mp="yuz9nsi2n5jq">
            <h2 className="font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-136" data-mp="13taokhn8468t">
              Explorá el sistema
            </h2>
            <ul className="mt-4 space-y-2" data-id="element-137" data-mp="18lk73cm0e412">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-138" data-mp="1ckt4crg9ck1d">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 font-sans text-[0.84rem] font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-139" data-mp="1cnyu88wpnpy5">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-gold transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden strokeWidth={2.5} data-id="element-140" data-mp="3od83n6x41ujc" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-141" data-mp="21kpgzxlpcb59">
            <h2 className="font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-142" data-mp="1wnp9rjd492ck">
              Soporte
            </h2>
            <ul className="mt-4 space-y-2 text-[0.84rem]" data-id="element-143" data-mp="2tcojl2tcmc6v">
              <li data-id="element-144" data-mp="2pcnu8n4pogl1">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-145" data-mp="2pc4lnx0yb4jo">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-146" data-mp="18zfr2qb78upn">
                    <MailIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-147" data-mp="1414j6l4gsua2" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-148" data-mp="2woke28ebi6u2">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-149" data-mp="2iv1hst0mfua2">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-150" data-mp="31lsti182zwrm">
                    <InstagramIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-151" data-mp="36jufatww6a6s" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-152" data-mp="1v5qmvs5ycu3u">
                <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-taupe transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-153" data-mp="1v69twdu2dy33">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-154" data-mp="1rouigl4dcpai">
                    <GlobeIcon className="h-4 w-4 text-gold" aria-hidden strokeWidth={2.5} data-id="element-155" data-mp="13yhzmf7l5855" />
                  </span>
                  www.creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 font-sans text-[0.74rem] text-taupe/80" data-id="element-156" data-mp="18wtamt9m9ooy">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-157" data-mp="l5nxilv29aic">
              <a href={link.href} className="transition-colors duration-200 ease-out hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-158" data-mp="g8npi5enhxol">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-5 border-t border-stone pt-5" data-id="element-159" data-mp="2q0yocn1rjmni">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-160" data-mp="2v01ihcg7g8gp">
            <p className="font-sans text-[0.74rem] text-taupe/80" data-id="element-161" data-mp="1xcay0d25q733">
              © Creativo Digital™ 2026 — Todos los derechos reservados.
            </p>
            <p className="font-sans text-[0.74rem] text-taupe/80" data-id="element-162" data-mp="22b4aq39mdu27">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-bold text-gold-deep transition-colors duration-200 ease-out hover:text-charcoal focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold" data-id="element-163" data-mp="27c1tagyjkq48">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}